import { Card, CompartmentCard } from "@/src/components/cards";
import {
  openConfirmDialog,
  openDeleteDialog,
  openDrawer,
} from "@/src/components/dialogs";
import {
  FetchableList,
  ListConstructor,
} from "@/src/components/fetchableLists";
import { openSinglePickerList } from "@/src/components/singlePicker";
import { Exam, ExamStep, Sample } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId } from "@/src/utils/utils";
import { useState } from "react";
import { openExamStepsPicker } from "./examStepsPicker";
import { getStandardConfidentiality } from "../patients/confidentialitiesHook";
import { openAnapathStepInfo } from "./anapathStepInfo";
import { openAnapathStepActionsDialog } from "./anapathStepActions";
import { AnapathStepCard } from "./anapathStepCard";
import { ReorderableItems } from "@/src/components/reorderable";
import { Button } from "@/src/components/buttons";

export default function AnapathStepsCompartment({
  sample,
  onChange,
}: {
  sample: Sample;
  onChange: (sample: Sample) => void;
}) {
  const [reload, setReload] = useState(0);
  const [searchKey, setSearchKey] = useState<string | null>(null);
  const [examSteps, setExamSteps] = useState(sample.steps || []);
  return (
    <div className="c1 gap10">
      <ListConstructor
        isLoading={false}
        isError={false}
        data={sample.steps || []}
        emptyChild={<div></div>}
      >
        <div className="c1 gap10">
          <ReorderableItems
            items={sample.steps || []}
            listId="examSteps"
            listType={"examSteps"}
            onReorder={async (newItems) => {
              await apiFetch("samples", "addOne", {
                sample: {
                  id: getItemId(sample),

                  steps: newItems,
                } as Sample,
              });
              sample.steps = newItems;
            }}
          >
            {sample.steps?.map((step) => {
              if (!step) return null;
              return (
                <AnapathStepCard
                  key={step.id}
                  sample={sample}
                  step={step}
                  onChange={onChange}
                />
              );
            })}
          </ReorderableItems>
        </div>
      </ListConstructor>
    </div>
  );
}
